import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { inventarioAPI } from '../services/api';

const Kardex = () => {
  const { productoId } = useParams();
  const [producto, setProducto] = useState(null);
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await inventarioAPI.getKardex(productoId);
        if (res.data.success) { setProducto(res.data.producto); setMovimientos(res.data.data); }
      } catch (e) { toast.error('Error al cargar kardex'); }
      finally { setLoading(false); }
    };
    load();
  }, [productoId]);

  const getTipo = (t) => ({ entrada: <span className="badge bg-success">Entrada</span>, salida: <span className="badge bg-danger">Salida</span>, ajuste: <span className="badge bg-warning">Ajuste</span> }[t] || <span className="badge bg-secondary">{t}</span>);

  const totales = movimientos.reduce((acc, m) => {
    if (m.tipo_movimiento === 'entrada') acc.entradas += m.cantidad;
    else if (m.tipo_movimiento === 'salida') acc.salidas += m.cantidad;
    return acc;
  }, { entradas: 0, salidas: 0 });

  if (loading) return <div className="loading-container"><div className="spinner-border text-primary"></div></div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <Link to="/inventario" className="btn btn-outline-secondary btn-sm me-3"><i className="bi bi-arrow-left me-1"></i>Volver</Link>
          <span className="fs-5"><strong>{producto?.nombre}</strong> <code className="ms-2">{producto?.codigo}</code></span>
        </div>
        <div className="badge bg-primary fs-6 px-3 py-2">Stock Actual: {producto?.stock_actual}</div>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-4"><div className="stat-card"><div className="d-flex justify-content-between"><div><p className="stat-label mb-1">Total Entradas</p><h4 className="stat-value mb-0 text-success">+{totales.entradas}</h4></div><div className="stat-icon bg-success bg-opacity-10 text-success"><i className="bi bi-arrow-down-circle"></i></div></div></div></div>
        <div className="col-md-4"><div className="stat-card"><div className="d-flex justify-content-between"><div><p className="stat-label mb-1">Total Salidas</p><h4 className="stat-value mb-0 text-danger">-{totales.salidas}</h4></div><div className="stat-icon bg-danger bg-opacity-10 text-danger"><i className="bi bi-arrow-up-circle"></i></div></div></div></div>
        <div className="col-md-4"><div className="stat-card"><div className="d-flex justify-content-between"><div><p className="stat-label mb-1">Stock Actual</p><h4 className="stat-value mb-0 text-primary">{producto?.stock_actual}</h4></div><div className="stat-icon bg-primary bg-opacity-10 text-primary"><i className="bi bi-box-seam"></i></div></div></div></div>
      </div>

      <div className="card"><div className="card-header"><h5 className="mb-0"><i className="bi bi-clock-history me-2"></i>Historial de Movimientos</h5></div>
        <div className="card-body p-0">
          {movimientos.length === 0 ? <div className="empty-state py-5"><i className="bi bi-clock-history"></i><h5>No hay movimientos</h5></div>
          : <div className="table-responsive"><table className="table table-hover mb-0">
            <thead><tr><th>Fecha/Hora</th><th>Tipo</th><th className="text-center">Cantidad</th><th className="text-center">Stock Anterior</th><th className="text-center">Stock Posterior</th><th>Motivo</th><th>Referencia</th></tr></thead>
            <tbody>{movimientos.map(m => (
              <tr key={m.id}>
                <td>{new Date(m.created_at).toLocaleString('es-EC')}</td>
                <td>{getTipo(m.tipo_movimiento)}</td>
                <td className="text-center"><strong className={m.tipo_movimiento === 'entrada' ? 'text-success' : 'text-danger'}>{m.tipo_movimiento === 'entrada' ? '+' : '-'}{m.cantidad}</strong></td>
                <td className="text-center">{m.stock_anterior}</td>
                <td className="text-center"><strong>{m.stock_posterior}</strong></td>
                <td>{m.motivo || '-'}</td>
                <td>{m.referencia_tipo === 'compra' && m.referencia_numero ? <span className="badge bg-info">{m.referencia_numero}</span> : m.referencia_tipo || '-'}</td>
              </tr>
            ))}</tbody>
          </table></div>}
        </div>
      </div>
    </div>
  );
};

export default Kardex;
